import { render, staticRenderFns } from "./BookADemo.vue?vue&type=template&id=2923b63c"
import script from "./BookADemo.vue?vue&type=script&lang=ts"
export * from "./BookADemo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports